import { ElementRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { ReportModel } from "../../insa-models";
import { InsaService, LocalizeService } from "../../insa-services";
import { appStateProvider } from "../../insa-providers";
import { appConfig } from "../../../insaweb.config";

@Component({
  selector: "insaweb-tiles",
  templateUrl: "tile.component.html",
})
export class TilesComponent implements OnInit, OnDestroy {
  private report: ReportModel;
  private selectedCurrency: string;
  private reportSubscription;
  private isMobileDevice: boolean = false;
  private screenWidthSupscription;
  private useLegacyIcons: boolean = true;
  constructor(
    private _appStateProvider: appStateProvider,
    private _insaService: InsaService,
    private _router: Router,
    private _localize: LocalizeService,
    private _element: ElementRef,
  ) {
    this.reportSubscription = this._insaService.CreateReportEvent.subscribe(
      (rep) => this.refreshReport(rep),
    );
    this.screenWidthSupscription = this._router.events.subscribe((route) => {
      this.removeTileOnMobileDevice();
    });
  }

  ngOnInit() {
    this.useLegacyIcons = appConfig.useLegacyIcons;
  }

  private refreshReport(report: ReportModel) {
    if (report !== undefined) {
      this.selectedCurrency = this._appStateProvider.selectedCurrency.text;
      report !== null
        ? (this.report = report)
        : (this.report = new ReportModel());
      /* if (report !== null) {
                this.report = report;
            } else {
                this.selectedCurrency = this._appStateProvider.selectedCurrency.text;
                this.report = new ReportModel();
            }*/
      setTimeout(
        () => this._localize.applyTranslations(this._element.nativeElement),
        0,
      );
    }
  }

  private getImageStyleForPerformanceTW() {
    if (this.report.TWPerformance > 0) {
      return "Images/progress_up.png";
    } else if (this.report.TWPerformance === 0) {
      return "Images/progress.png";
    } else {
      return "Images/progress_down.png";
    }
  }

  private getImageStyleForProfitLoss() {
    if (this.report.TotalProfit > 0) {
      return "Images/progress_up.png";
    } else if (this.report.TotalProfit === 0) {
      return "Images/progress.png";
    } else {
      return "Images/progress_down.png";
    }
  }

  private parseToIntegerWithRounding(num) {
    return Math.round(parseFloat(num));
  }

  private removeTileOnMobileDevice() {
    if (window.innerWidth < 768 && this._router.url !== "/home") {
      this.isMobileDevice = true;
    } else {
      this.isMobileDevice = false;
    }
  }

  private onResize(event) {
    this.removeTileOnMobileDevice();
  }

  ngAfterViewInit() {
    this.removeTileOnMobileDevice();
    this.refreshReport(this._insaService.report);
  }

  ngOnDestroy() {
    this.reportSubscription.unsubscribe();
    this.screenWidthSupscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-settings-and-tiles/tile.component.ts